import { Navigate, useLocation } from "react-router-dom";
import { useAuthSession } from "../../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { status, accountType } = useAuthSession();
  const location = useLocation();

  if (status === "loading") return null;

  if (status !== "authenticated") {
    return (
      <Navigate
        to={
          accountType === "partner" || location.pathname.startsWith("/partner/")
            ? "/partner/login"
            : "/admin/login"
        }
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
